<template>
  <div class="container">
    <van-nav-bar :title="$t('bindCard.title')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="main-box">
      <div class="label">{{ $t('bindCard.msg') }}</div>
      <van-cell-group>
        <van-field v-model="branch" :label="$t('姓氏')"  :placeholder="$t('请输入姓氏')" />
        <van-field v-model="branch_number"  :label="$t('名字')"  :placeholder="$t('请输入名字')" />
        <van-field v-model="bankinfo"  :label="$t('银行名称')"  :placeholder="$t('请输入银行名称')" />
        <van-field v-model="financial_institution"  :label="$t('ACH')"  :placeholder="$t('请输入ACH')" />
        <van-field v-model="account_number"  :label="$t('账号')"  :placeholder="$t('请输入账号')" />
        <van-field v-model="bankid" :label="$t('地址')" :placeholder="$t('请输入地址')" />
      </van-cell-group>
      <p>{{ $t("bindCard.hint") }}</p>
    </div>
    <van-button class="bindCard" type="default" @click="bindCard()">{{ $t("msg.确认绑卡") }}</van-button>
    <van-popup v-model="showBank" round position="bottom" :style="{ height: '35%' }" >
      <van-picker
          show-toolbar
          :columns="banks"
          @confirm="onConfirm"
          @cancel="onCancel"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banks: [],
      showBank:false,
      userInfo:{},
      bankid:"",
      bank:"",
      financial_institution:"",
      branch:"",
      branch_number:"",
      lang: "",
      bankinfo: "",
      account_number: ""
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    bindCard(){
      if(!this.branch){
        return this.$toast(this.$t("请输入姓氏"));
      }
      if(!this.branch_number){
        return this.$toast(this.$t("请输入名字"));
      }
      if(!this.bankinfo){
        return this.$toast(this.$t("请输入银行名称"));
      }
      if(!this.financial_institution){
        return this.$toast(this.$t("请输入ACH"));
      }
      if(!this.account_number){
        return this.$toast(this.$t("请输入账号"));
      }

      if(!this.bankid) {
        return this.$toast(this.$t("请输入地址"));
      }
      this.$http({
        method: 'post',
        data:{
          branch: this.branch,
          branch_number: this.branch_number,
          bankinfo: this.bankinfo,
          bankid: this.bankid,
          financial_institution: this.financial_institution,
          account_number: this.account_number
        },
        url: 'user_set_bank'
      }).then(res=>{
        if(res.code === 200){
          this.$router.push({path:'/Mine'})
        }
        this.$toast(this.$t("msg."+res.msg));
      })
    },
    showSelectBanks(){
      this.showBank = true;
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          //this.$toast(res.msg);
        }
      })
    },
    getBankList(){
      this.$http({
        method: 'get',
        url: 'sys_get_banks'
      }).then(res=>{
        if(res.code === 200){
          this.banks = res.data;
        }else if(res.code ===401){
          this.$toast(this.$t("msg."+res.msg));
        }
      })
    },
    onConfirm(value) {
      this.bank = value.text
      this.showBank = false;
    },
    onCancel() {
      this.showBank = false;
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.is_bind = true;
          }else {
            this.is_bind = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    this.lang = localStorage.getItem("lang");
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getBankList();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
::v-deep .van-field__label{
  width: auto;
  margin-right: 10px;
}
</style>
